var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89995 8.99995L16.7625 2.13745C17.0156 1.88433 17.0156 1.49058 16.7625 1.23745C16.5093 0.984326 16.1156 0.984326 15.8625 1.23745L8.99995 8.09995L2.13745 1.23745C1.88433 0.984326 1.49058 0.984326 1.23745 1.23745C0.984326 1.49058 0.984326 1.88433 1.23745 2.13745L8.09995 8.99995L1.23745 15.8625C0.984326 16.1156 0.984326 16.5093 1.23745 16.7625C1.34995 16.875 1.5187 16.9593 1.68745 16.9593C1.8562 16.9593 2.02495 16.9031 2.13745 16.7625L8.99995 9.89995L15.8625 16.7625C15.975 16.875 16.1437 16.9593 16.3125 16.9593C16.4812 16.9593 16.65 16.9031 16.7625 16.7625C17.0156 16.5093 17.0156 16.1156 16.7625 15.8625L9.89995 8.99995Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6d7e732f6e43e6ef85694b0822ec0893.svg";
export { ForwardRef as ReactComponent };